export function getTimeAttackCutoff(event) {
  const rule = event?.advancementRules?.[0]
  if (!rule || !Number.isInteger(rule.topN) || rule.topN < 1) return null
  return { position: rule.topN, label: 'Qualification Cut-Off' }
}
